import { Col, Container, Row } from 'react-bootstrap';
import UserInfo from './UserInfo';
import { useAuth } from './hooks/useAuth';

function Welcome() {
  const auth = useAuth();

  return (
    <Container style={{ paddingLeft: 0, margin: 0 }}>
      <Row>
        <Col>
          <h2>Welcome!</h2>
        </Col>
        <UserInfo name={auth?.name} upn={auth?.upn} />
      </Row>
    </Container>
  );
}

export default Welcome;
